import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import React from "react";
import LinkItem, { NavItem } from "./LinkItem";

interface CollapseLinkItemProps {
  navItem: NavItem;
}

const CollapseLinkItem: React.FC<CollapseLinkItemProps> = ({ navItem }) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <ListItem button onClick={handleClick}>
        <ListItemIcon>{navItem.icon}</ListItemIcon>
        <ListItemText primary={navItem.title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        style={{ backgroundColor: "#e8e8e8" }}
      >
        <List component="div" disablePadding>
          {navItem.children?.map((menu: NavItem, idx: number) => {
            return <LinkItem key={idx} navItem={menu} />;
          })}
        </List>
      </Collapse>
    </>
  );
};

export default CollapseLinkItem;
